/**
 * @generated SignedSource<<c14106cb1a5fe7f4c70ff0f8fde5ca89>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrderEditMainTransport_order$data = {
  readonly flightBookingFailed: boolean | null;
  readonly flightBookingId: number | null;
  readonly flightBookingTransactionId: string | null;
  readonly flights: {
    readonly priceLive: number;
    readonly " $fragmentSpreads": FragmentRefs<"FlightShortDetails_flight">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"OrderEditFlightTicket_order">;
  readonly " $fragmentType": "OrderEditMainTransport_order";
};
export type OrderEditMainTransport_order$key = {
  readonly " $data"?: OrderEditMainTransport_order$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrderEditMainTransport_order">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrderEditMainTransport_order",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "flightBookingFailed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "flightBookingId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "flightBookingTransactionId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FlightJson",
      "kind": "LinkedField",
      "name": "flights",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "priceLive",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FlightShortDetails_flight"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OrderEditFlightTicket_order"
    }
  ],
  "type": "Order",
  "abstractKey": null
};

(node as any).hash = "a57d544ea55dd3fce5a1c90a2ccde7af";

export default node;
